export default "__VITE_ASSET__Hq1ZBQ8f__"